(function () {
  // --- CONFIGURACIÓN ---
  const targetClasses = [
    'is--blockidbrand',
    'is--blockidingredient',
    'is--blockid_price',
    'is--blockidflavor',
    'is--blockidbenefit',
    'is--blockidservings'
  ];
  // --------------------

  const collapsibleState = {};

  function inicializarCollapsible(blockElement, uniqueId) {
    if (blockElement.dataset.collapsibleInitialized) return;
    blockElement.dataset.collapsibleInitialized = 'true';

    const title = blockElement.querySelector('.t4s-facet-title');
    const content = blockElement.querySelector('.t4s-facet-content');

    if (!title || !content) return;

    title.style.cursor = 'pointer';
    title.style.userSelect = 'none';
    title.style.position = 'relative';
    title.style.paddingRight = '25px';

    content.style.overflow = 'hidden';
    content.style.transition = 'max-height 0.4s ease-in-out';

    const icon = document.createElement('span');
    icon.style.cssText = "position:absolute; right:10px; top:50%; transform:translateY(-50%); font-size:20px; font-weight:bold;";
    title.appendChild(icon);

    const shouldStartOpen = collapsibleState[uniqueId] === 'open';

    if (shouldStartOpen) {
      blockElement.classList.remove('is-collapsed');
      setTimeout(() => {
        content.style.maxHeight = content.scrollHeight + 'px';
      }, 0);
      icon.textContent = '−';
    } else {
      blockElement.classList.add('is-collapsed');
      content.style.maxHeight = '0px';
      icon.textContent = '+';
    }

    title.addEventListener('click', function () {
      const isNowCollapsed = blockElement.classList.toggle('is-collapsed');

      if (isNowCollapsed) {
        content.style.maxHeight = '0px';
        icon.textContent = '+';
        collapsibleState[uniqueId] = 'closed';
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        icon.textContent = '−';
        collapsibleState[uniqueId] = 'open';

        // --- NUEVO: colapsar los demás bloques abiertos ---
        Object.keys(collapsibleState).forEach(id => {
          if (id !== uniqueId && collapsibleState[id] === 'open') {
            const otherBlock = document.querySelector(`.${id}`);
            if (otherBlock) {
              const otherContent = otherBlock.querySelector('.t4s-facet-content');
              const otherIcon = otherBlock.querySelector('.t4s-facet-title span:last-child');
              otherBlock.classList.add('is-collapsed');
              if (otherContent) otherContent.style.maxHeight = '0px';
              if (otherIcon) otherIcon.textContent = '+';
              collapsibleState[id] = 'closed';
            }
          }
        });
        // --- FIN NUEVO ---
      }
    });
  }

  function buscarYActivarCollapsibles() {
    targetClasses.forEach(className => {
      const elements = document.querySelectorAll(`.${className}`);
      elements.forEach(el => inicializarCollapsible(el, className));
    });
  }

  const targetNode = document.body;
  const config = { childList: true, subtree: true };

  const callback = function () {
    buscarYActivarCollapsibles();
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);

  buscarYActivarCollapsibles();
})();
